export const noop = () => {}

export const noopHandler = () => () => {}
